import { useTranslation } from 'react-i18next';
import { Card } from 'semantic-ui-react';
import styles from '../styles/Activity.module.scss';
import TitleContainer from '../TitleContainer';
import ActionRequired from './ActionRequired';
import { ActionDTO } from '@behavior/activity/dto/ActionDTO';
import { ActivityInitialDataResponse } from '@components/Activity/types/ActivityInitialDataResponse';
import { ActionState } from '@components/Activity/types/ActionState';

type Props = {
  actionState: ActionState;
  initialData?: ActivityInitialDataResponse;
  disabled?: boolean;
};

const ActionFormContainer = ({ actionState, initialData, disabled }: Props) => {
  const {
    actionCard,
    setActionCard,
    count,
    setCount,
    actionCardContent,
    setActionCardContent,
    actionCardContentList,
    setActionCardContentList,
  } = actionState;

  return (
    <div className={styles.component}>
      <Card className={styles.card}>
        <TitleContainer header="action.form.details.page.container.title" />
        <ActionRequired
          actionCard={actionCard}
          setActionCard={setActionCard}
          count={count}
          setCount={setCount}
          initialData={initialData}
          actionCardContent={actionCardContent}
          setActionCardContent={setActionCardContent}
          actionCardContentList={actionCardContentList}
          setActionCardContentList={setActionCardContentList}
          disabled={disabled}
        />
      </Card>
    </div>
  );
};

export default ActionFormContainer;
